import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PublicApi } from '../constants/public-api-constants';

export interface CompanionNumber {
  id: number;
  phone_number: string;
  is_verified: boolean;
  companion_enabled: boolean;
  is_primary: boolean;
  verified_at?: string | null;
  last_active_at?: string | null;
  created_at?: number | string;
}


/**
 * Campaign Companion (WhatsApp bot) connection management.
 * Talks to the Xano `luqta_whatsapp` group (user-authenticated dashboard calls).
 */
@Injectable({ providedIn: 'root' })
export class CompanionService {
  private http = inject(HttpClient);

  /** List the current user's connected / pending WhatsApp numbers. */
  listNumbers(): Observable<CompanionNumber[]> {
    return this.http.get<CompanionNumber[]>(PublicApi.COMPANION_NUMBERS_LIST);
  }

  /** Enable / disable the Companion for a verified number. */
  toggleNumber(numberId: number, enabled: boolean): Observable<CompanionNumber> {
    return this.http.post<CompanionNumber>(PublicApi.COMPANION_NUMBER_TOGGLE, {
      number_id: numberId,
      companion_enabled: enabled,
    });
  }

  /** Remove (disconnect) a number. */
  removeNumber(numberId: number): Observable<{ isSuccess: boolean; removed_id: number }> {
    return this.http.post<{ isSuccess: boolean; removed_id: number }>(
      PublicApi.COMPANION_NUMBER_REMOVE,
      { number_id: numberId },
    );
  }

  /** Enable/disable Companion for a user (self or, as admin, a team member); unlink revokes numbers. */
  setEnabled(targetUserId: number, enabled: boolean, unlink = false): Observable<any> {
    return this.http.post<any>(PublicApi.COMPANION_SET_ENABLED, {
      target_user_id: targetUserId,
      enabled,
      unlink,
    });
  }
}
